/**
 * DIV-012: maps the `error` (and optional `error_description`) query params that Better Auth's
 * OAuth callback redirects to `${APP_URL}/login` with (see apps/api/src/auth-options.ts
 * `onAPIError.errorURL`) to a plain-English message for the login page's <Alert>.
 *
 * Codes are Better Auth's own (traced in node_modules/better-auth/dist/oauth2/errors.mjs and
 * .../dist/oauth2/link-account.mjs — see the DIV-012 worksheet), plus `staff_only` /
 * `signup_disabled`, which is what a rejected DI Voices databaseHooks.user.create.before check
 * (auth-options.ts beforeUserCreate) surfaces as once it carries a `code`.
 */
const MESSAGES = {
  staff_only: {
    title: "This sign-in isn't available",
    body: 'DI Voices sign-in is for Diverse Integration staff only. If you think this is wrong, contact your DI Voices administrator.',
  },
  signup_disabled: {
    title: "This sign-in isn't available",
    body: 'DI Voices sign-in is for Diverse Integration staff only. If you think this is wrong, contact your DI Voices administrator.',
  },
  account_not_linked: {
    title: 'Account already exists',
    body: 'An account with this email already exists. Sign in with your password or the email link, then try again — or verify your email first.',
  },
  email_not_verified: {
    title: 'Email not verified',
    body: 'Verify your email address before signing in with Google or Microsoft.',
  },
  email_not_found: {
    title: 'No email address',
    body: "We couldn't get an email address from that sign-in. Make sure your Google or Microsoft account has one, then try again.",
  },
  access_denied: {
    title: 'Sign-in cancelled',
    body: 'You cancelled sign-in at Google/Microsoft.',
  },
  oauth_provider_not_found: {
    title: 'Sign-in not available',
    body: 'That sign-in method is not set up. Try email and password, or the email link.',
  },
};

/** Pure — no DOM/router access, so it's cheap to unit test and reuse anywhere the code is known. */
export function authErrorMessage(code, description) {
  const known = code ? MESSAGES[code] : undefined;
  if (known) return known;
  return {
    title: 'Sign-in did not complete',
    body: [description, `(error: ${code || 'unknown'})`].filter(Boolean).join(' '),
  };
}
